import styles from './menu-link.module.css';

export type MenuLinkProps = {
    label: string;
    url: string;
}

export const MenuLink = ({label, url}: MenuLinkProps) => {

  return <a className={styles.link} href={url}>{label}</a>
};
